import { useCallback, useLayoutEffect, useState } from 'react'

export const useIsTruncated = <T extends HTMLElement>() => {
  const [node, setNode] = useState<T | null>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  const measure = useCallback(() => {
    if (node) {
      setIsTruncated(node.scrollWidth > node.clientWidth)
    }
  }, [node])

  useLayoutEffect(() => {
    if (!node) {
      return
    }

    const observer = new ResizeObserver(measure)
    observer.observe(node)

    return () => observer.disconnect()
  }, [node, measure])

  useLayoutEffect(measure)

  return { ref: setNode, isTruncated }
}
